import { PaymentRulesPage } from '@/page-content/payment-rules';
export default PaymentRulesPage;